<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
        </div>
        <!-- <div class="row" *ngIf="!izlazna || razvoj"> -->
        <div class="row">
            <!-- Redni broj-->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR'"
                            formControlName="RedniBroj"
                            [ngClass]="{'is-invalid': submitted && fc.RedniBroj.invalid}"
                            [MaxLength]="13"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Sifra robe -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.SIFRA.SINGULAR'"
                            formControlName="Sifra"
                            [ngClass]="{'is-invalid': submitted && fc.Sifra.invalid}"
                            [MaxLength]="13"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Naziv robe -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.NAZIV.SINGULAR'"
                            formControlName="Naziv"
                            [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                            [MaxLength]="200"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Količina robe sa otpremnice -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtKolicina"
                            [Label]="'EOTPREMNICASTAVKA.KOLICINA.SINGULAR'"
                            formControlName="Kolicina"
                        >
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>
            <!-- Šifra jedinica mere -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.JEDINICAMERE.SINGULAR'"
                            formControlName="JedinicaMere"
                            [ngClass]="{'is-invalid': submitted && fc.JedinicaMere.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Pristigla Količina robe -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtPristiglaKolicina"
                            [Label]="'EPRIJEMNICASTAVKA.PRISTIGLAKOLICINA.SINGULAR'"
                            formControlName="PristiglaKolicina"
                            (OnBlur)="onPristiglaKolicinaChange($event)"
                        >
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>
            <!-- Primljena količina robe -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtPrimljenaKolicina"
                            [Label]="'EPRIJEMNICASTAVKA.PRIMLJENAKOLICINA.SINGULAR'"
                            formControlName="PrimljenaKolicina"
                            (OnBlur)="onPrimljenaKolicinaChange($event)"
                        >
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>
            <!-- Vraćena količina robe -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtVracenaKolicina"
                            [Label]="'EPRIJEMNICASTAVKA.VRACENAKOLICINA.SINGULAR'"
                            formControlName="VracenaKolicina"
                        >
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>            
        </div>
        <div class="row" *ngIf="!izlazna || razvoj">
            <!-- Akcizna roba - kategorija -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBA.SINGULAR'"
                            formControlName="AkciznaRoba"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRoba.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>
            <!-- Akcizna roba - tip pakovanja -->
            <div class="col-lg-4">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJA.SINGULAR'"
                            formControlName="AkciznaRobaTipPakovanja"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaTipPakovanja.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>        
            <!-- Akcizna roba - tip pakovanja vrednost -->
            <div class="col-lg-2">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            #tipPakovanjaVrednost2
                            name="txtAkciznaRobaTipPakovanjaVrednost1"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBATIPPAKOVANJAVREDNOST.SINGULAR'"
                            formControlName="AkciznaRobaTipPakovanjaVrednost"
                        >
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>              
            <!-- Akcizna roba - šifra marke -->
            <div class="col-lg-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-input
                            [Type]="'text'"
                            [Label]="'EOTPREMNICASTAVKA.AKCIZNAROBASIFRAROBNEMARKE.SINGULAR'"
                            formControlName="AkciznaRobaSifraRobneMarke"
                            [ngClass]="{'is-invalid': submitted && fc.AkciznaRobaSifraRobneMarke.invalid}"
                            [MaxLength]="50"
                        >
                        </yt-input>
                    </div>
                </div>
            </div>              
        </div>
        <div class="row">
            <div class="col-md-12">
                <label class="toggle">
                    <input
                        #toggleDodatniAtributiCheckbox
                        class="toggle-checkbox"
                        type="checkbox"
                        [(ngModel)]="showDodatniAtributi"
                        [ngModelOptions]="{standalone: true}"
                        (change)="onToggleDodatniAtributi()"
                    >

                    <div class="toggle-switch"></div>

                    <span class="toggle-label">
                        Dodatni atributi
                    </span>

                    <!-- badge: prikazuje broj unetih atributa kada je skriveno -->
                    <span *ngIf="!showDodatniAtributi && Item?.BrojDodatnihAtributa > 0"
                        class="badge badge-info ml-2">
                        {{ Item.BrojDodatnihAtributa }} uneto
                    </span>
                </label>

                <!-- <div class="btn-group float-right" *ngIf="izlazna"> -->
                <!-- <div class="btn-group float-right">
                    <button type="button" class="btn btn-outline-primary" (click)="Save()" [disabled]="saveDisabled"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                    <button type="button" class="btn btn-outline-primary" (click)="Reset()"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                </div> -->
            </div>
        </div>

        <!-- Dodatni atributi -->
        <div class="row" *ngIf="showDodatniAtributi">
            <div class="col-md-12">
                <yt-eprijemnica-stavka-dodatni-atribut-update-container
                    #nestedInline
                    [DetailModelData]="modelData.MainList.DetailList[2]"
                    [ParentPropertyName]="'EPrijemnicaStavkaID'"
                    [ParentPropertyValue]="Item?.ID"
                    [NestedInline]="true"
                    [Level]="'attribute'"
                >
                </yt-eprijemnica-stavka-dodatni-atribut-update-container>
            </div>
        </div>
    </form>
</div>